<template>
  <div class="staffEmployeePopup">
    <div>
      <span
        class="mr-4 cursor-pointer"
        :class="[toggle_emp_form ? 'title' : 'title-tab']"
        @click="toggleEmpSection(true)"
        >Employee Details</span
      >
      <span
        v-if="employeeData != undefined"
        class="ml-4 cursor-pointer"
        :class="[!toggle_emp_form ? 'title' : 'title-tab']"
        @click="toggleEmpSection(false)"
        >Skills</span
      >
    </div>

    <div class="mt-4">
      <div v-if="toggle_emp_form">
      <div style="overflow-y: auto; padding: 0 10px; padding-top: 15px;">
        <div class="flex justify-between items-center">
          <div class="flex w-full justify-between items-center">
            <p class="pb-1 w-1/2">
              Employee Id <span style="color: red">*</span>
            </p>
            <div class="w-1/2">
              <el-input
                v-model="employeeDetails.employee_id"
                v-validate="showAddEmployeePopup ? 'required' : ''"
                class="baseInput lowercase"
                style="width: 100%"
                placeholder="Employee Id"
                :name="'employee_id'"
                size="small"
                :disabled="employeeData != undefined"
                @change="
                  $emit('staffOpenPopUp'),
                    checkValidation(employeeDetails.employee_id)
                "
              />
              <p>
                <span
                  :v-show="errors.has('employee_id')"
                  class="text-red-dark text-xs"
                >
                  {{ errors.first("employee_id") ? "field is required" : "" }}
                </span>
              </p>
              <p v-if="responseData.response_msg" class="mt-1">
                <span class="text-green-dark text-xs capitalize">{{ responseData.response_msg }}</span>
              </p>
            </div>
          </div>

          <div class="flex w-full justify-between items-center">
            <p class="text-center pb-1 w-1/2">
              Status <span style="color: red">*</span>
            </p>
            <div class="w-1/2">
              <el-select
                v-model="employeeDetails.active"
                v-validate="showAddEmployeePopup ? 'required' : ''"
                style="width: 100%"
                :name="'Status'"
                placeholder="Active"
                size="small"
                @change="openWarningDialog()"
              >
                <el-option :value="true" label="Active" selected
                  >Active</el-option
                >
                <el-option :value="false" label="Inactive">Inactive</el-option>
              </el-select>
              <p>
                <span
                  :v-show="errors.has('Status')"
                  class="text-red-dark text-xs"
                >
                  {{ errors.first("Status") ? "field is required" : "" }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="flex justify-between items-center">
          <div class="flex w-full justify-between items-center">
            <p class="pb-1 w-1/2">Full Name <span style="color: red">*</span></p>
            <div class="w-1/2">
              <el-input
                v-model="employeeDetails.full_name"
                v-validate="showAddEmployeePopup ? 'required' : ''"
                class="baseInput"
                style="width: 100%"
                placeholder="Employee Name"
                :name="'full_name'"
                size="small"
                @change="$emit('staffOpenPopUp')"
              />
              <p>
                <span
                  :v-show="errors.has('full_name')"
                  class="text-red-dark text-xs mt-4"
                >
                  {{ errors.first("full_name") ? "field is required" : "" }}
                </span>
              </p>
            </div>
          </div>

          <div class="flex w-full justify-between items-center">
            <p class="text-center pb-1 w-1/2">Designation <span style="color: red">*</span></p>
            <div class="w-1/2">
                <el-select
                  v-model="employeeDetails.designation"
                  v-validate="showAddEmployeePopup ? 'required' : ''"
                  style="width: 100%"
                  placeholder="designation"
                  :name="'designation'"
                  size="small"
                  filterable
                  @input="addDesignation($event)"
                  @change="selectDesignInfo(employeeDetails.designation)"
                  :disabled="companyData && companyData.id == '5bfb5014-8af3-4980-90fa-5d19dcad4679' && employeeDetails.id ? true : false"
                >
                  <!-- <el-option label="add new" value="add new" style="color: #e29d5a"
                    >Add-Edit Desgination</el-option
                  > -->
                  <el-option
                    v-for="(designation, Dindex) in designationList"
                    :key="Dindex"
                    :value="designation.id"
                    :label="designation.name"
                  ></el-option>
                </el-select>
                <!-- <p>
                  <span :v-show="errors.has('designation')" class=" text-red-dark text-xs mt-4">
                    {{ errors.first("designation")  ? "field is required" : ""}}
                  </span>
                </p> -->
              </div>
          </div>
        </div>

        <!-- <div class="flex items-center my-4">
          <p class=" pb-1 w-1/4 ">Full Name <span style="color:red;">*</span></p>
          <div class="w-1/4">
          <el-input
          v-model="employeeDetails.full_name"
          v-validate="showAddEmployeePopup ? 'required' : ''"
          class="baseInput"
          style="width: 100%;"
          placeholder="Employee Name"
          :name="'full_name'"
          size="small"
          @change="$emit('staffOpenPopUp')"
          />
          <p>
          <span :v-show="errors.has('full_name')" class=" text-red-dark text-xs mt-4">
          {{ errors.first("full_name") ? "field is required" : ""}}
          </span>
          </p>
          </div>
        </div> -->

        <div v-if="isMySB" class="flex items-center mb-4">
          <p class="pb-1 w-1/4">Alias</p>
          <div class="w-1/4">
            <el-input
                v-model="employeeDetails.alias"
                class="baseInput"
                style="width: 100%"
                placeholder="Alias"
                :name="'alias'"
                size="small"
                @change="$emit('staffOpenPopUp')"
              />
          </div>
        </div>

        <div class="flex items-center mb-4">
          <p class="pb-1 w-1/4">Secondary Store</p>
          <div class="w-1/4">
            <el-select
              v-model="employeeDetails.secondary_stores"
              filterable
              multiple
              collapse-tags
              style="width: 100%"
              :name="'Secondary'"
              placeholder="Select Store"
              size="small"
              @change="$emit('staffOpenPopUp')"
            >
              <el-option
                v-for="(store, storeIndex) in secondaryStores"
                :key="storeIndex"
                :value="store.id"
                :label="store.name"
                :disabled="storeName == store.id"
              >
                {{ store.name }}
              </el-option>
            </el-select>
          </div>
        </div>

        <div v-if="departmentList.length" class="flex items-center my-4">
          <p class="pb-1 w-1/4">Department <span style="color: red">*</span></p>
          <div class="w-1/4">
            <el-select
              v-model="employeeDetails.store_department"
              v-validate="showAddEmployeePopup ? 'required' : ''"
              filterable
              style="width: 100%"
              :name="'Department'"
              placeholder="Select Department"
              size="small"
              @change="
                $emit('staffOpenPopUp'),
                  filterFunctionsByDepartment(employeeDetails.store_department)
              "
              :disabled="companyData && companyData.id == '5bfb5014-8af3-4980-90fa-5d19dcad4679' && employeeDetails.id ? true : false"
            >
              <el-option
                v-for="(departments, departmentsIndex) in departmentList"
                :key="departmentsIndex"
                :value="departments.id"
                :label="departments.department"
              >
                {{ departments.department }}
              </el-option>
            </el-select>
            <p>
              <span
                :v-show="errors.has('Department')"
                class="text-red-dark text-xs"
              >
                {{ errors.first("Department") ? "field is required" : "" }}
              </span>
            </p>
          </div>
        </div>

        <div class="flex justify-between items-center">
          <div class="flex w-full items-center">
            <p class="pb-1 w-1/4">Functions <span style="color: red">*</span></p>
            <div class="w-1/4">
              <el-select
                v-model="employeeDetails.function"
                v-validate="showAddEmployeePopup ? 'required' : ''"
                filterable
                multiple
                collapse-tags
                style="width: 100%"
                :name="'Functions'"
                placeholder="Select Functions"
                size="small"
                @change="selectFunction(employeeDetails.function)"
              >
                <!-- @change="selectPrimary(employeeDetails.function)" -->
                <el-option
                  style="color: #e29d5a; width: 100px; z-index: 1;"
                  value="selectAll"
                  label="Select All"
                >
                </el-option>
                <el-option
                  style="color: #e29d5a; margin-top: -35px; margin-right: 0px; text-align: right; z-index: 0;"
                  value="clearAll"
                  label="Clear All"
                >
                </el-option>
                <el-option
                  v-for="(type, typeIndex) in filtered_functions"
                  :key="typeIndex"
                  :value="type.id"
                  :label="type.function"
                >
                  {{ type.function }}
                </el-option>
              </el-select>
              <p>
                <span
                  :v-show="errors.has('Functions')"
                  class="text-red-dark text-xs"
                >
                  {{ errors.first("Functions") ? "field is required" : "" }}
                </span>
              </p>
            </div>
          </div>
          <!-- <div class="flex w-full justify-around items-center">
  <p class="text-center pb-1 w-1/2 ">Secondary Function</p>
  <div class="w-1/2">
  <el-select
  v-model="employeeDetails.secondary_functions"
  multiple
  collapse-tags
  style="width: 100%;"
  placeholder="Secondary Function"
  size="small"
  @change="displayedRole(employeeDetails.secondary_functions)"
  >
  <el-option
  v-for="(type, typeIndex) in functions"
  :key="typeIndex"
  :value="type.id"
  :label="type.function"
  >
  {{ type.function }}
  </el-option>
  </el-select>
  </div>
  </div> -->
        </div>

        <div class="flex justify-between items-center">
          <!-- <div class="flex w-full justify-end">
            <span v-for="(primery, index) in functions" :key="index">
            <span class="m-2 p-1 text-white text-xs rounded break-words leading-tight" :style="{ background: color[index] }">
            {{ primery.function }}
            </span>
            </span>
            </div>
            <div class="flex w-full flex-wrap justify-end">
            <span
            v-for="(item, index) in selectedRole"
            :key="index"
            class="m-2 p-1 text-white text-xs rounded break-words leading-tight"
            :style="{ background: item.color }"
            >{{ item.function }}</span
            >
          </div> -->
        </div>

        <div class="flex items-center my-4">
          <div class="flex w-full items-center">
            <p class="pb-1 w-1/4">Gender <span style="color: red">*</span></p>
            <div class="w-1/4">
              <el-select
                v-model="employeeDetails.gender"
                v-validate="showAddEmployeePopup ? 'required' : ''"
                style="width: 100%"
                :name="'gender'"
                placeholder="Gender"
                size="small"
                @change="$emit('staffOpenPopUp')"
                :disabled="companyData && companyData.id == '5bfb5014-8af3-4980-90fa-5d19dcad4679' && employeeDetails.id ? true : false"
              >
                <el-option
                  v-for="(gender, genderIndex) in gender_list"
                  :key="genderIndex"
                  :value="gender"
                >
                  {{ gender }}
                </el-option>
              </el-select>
              <p>
                <span
                  :v-show="errors.has('gender')"
                  class="text-red-dark text-xs"
                >
                  {{ errors.first("gender") ? "field is required" : "" }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="flex justify-between items-center">
          <div class="flex w-full justify-between items-center" style="margin-bottom: 0">
            <p class="pb-1 w-1/2">Type <span style="color: red">*</span></p>
            <div class="w-1/2">
              <el-select
                v-model="employeeDetails.employee_type"
                v-validate="showAddEmployeePopup ? 'required' : ''"
                style="width: 100%"
                :name="'employee_type'"
                placeholder="Select Type"
                size="small"
                @change="
                  setTotalHrs(employeeIndex, employeeDetails.employee_type)
                "
                :disabled="companyData && companyData.id == '5bfb5014-8af3-4980-90fa-5d19dcad4679' && employeeDetails.id ? true : false"
              >
                <el-option
                  v-for="(type, typeIndex) in select_shift_list"
                  :key="typeIndex"
                  :value="type"
                  :label="type"
                >
                  {{ type }}
                </el-option>
              </el-select>
              <p>
                <span
                  :v-show="errors.has('employee_type')"
                  class="text-red-dark text-xs"
                >
                  {{ errors.first("employee_type") ? "field is required" : "" }}
                </span>
              </p>
            </div>
          </div>

          <div class="flex w-full justify-around items-center" style="margin-bottom: 0">
            <p class="text-center pb-1 w-1/2">
              Total Hrs <span style="color: red">*</span>
            </p>
            <div class="w-1/2">
              <el-time-select
                v-model="employeeDetails.duration"
                v-validate="'required'"
                style="width: 100%"
                :picker-options="{
                  start: '01:00',
                  step: '00:30',
                  end: '23:59',
                }"
                placeholder="HH:mm"
                :name="'duration'"
                size="small"
                :disabled="companyData && companyData.id == '5bfb5014-8af3-4980-90fa-5d19dcad4679' && employeeDetails.id ? true : false"
              >
              </el-time-select>
              <p>
                <span
                  :v-show="errors.has('duration')"
                  class="text-red-dark text-xs"
                >
                  {{ errors.first("duration") ? "field is required" : "" }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="flex items-center my-4">
          <p class="pb-1 w-1/4">Mobile No</p>
          <div class="w-1/4">
            <el-input
              v-model="employeeDetails.phone"
              v-validate="'numeric|digits:10'"
              class="baseInput"
              style="width: 100%"
              :name="'Mobile No'"
              placeholder="Mobile No"
              size="small"
              @change="$emit('staffOpenPopUp')"
            />
            <p>
              <span
                :v-show="errors.has('Mobile No')"
                class="text-red-dark text-xs"
              >
                {{
                  errors.first("Mobile No") ? "enter a valid mobile number" : ""
                }}
              </span>
            </p>
          </div>
        </div>

        <div class="flex items-center my-4">
          <p class="pb-1 w-1/4">Email</p>
          <div class="w-1/4">
            <el-input
              v-model="employeeDetails.email"
              class="baseInput email"
              style="width: 100%"
              :name="'email'"
              placeholder="email"
              size="small"
              @change="checkValidationByAPIEmail(employeeDetails.email)"
              :disabled="employeeData != undefined"
            />
            <!-- @input="checkValidationEmail(employeeDetails.email)" -->
            <p>
              <span :v-show="errors.has('email')" class="text-red-dark text-xs">
                {{ errors.first("email") ? "enter a valid email id" : "" }}
              </span>
            </p>
            <p v-if="!uniqEmail">
              <span class="text-red-dark text-xs"> Email already exists </span>
            </p>
          </div>
        </div>

        <div class="flex payType items-center my-4">
          <p class="pb-1 w-1/4">Pay Type</p>
          <div class="w-1/4">
            <el-select
              v-model="employeeDetails.paytype.pay_type"
              style="width: 100%"
              placeholder="Pay type"
              size="small"
              @change="changedPayType(employeeDetails.paytype.pay_type)"
            >
              <el-option value="hourly" label="Hourly"></el-option>
              <el-option value="daily" label="Daily"></el-option>
              <el-option value="weekly" label="Weekly"></el-option>
              <el-option value="monthly" label="Monthly"></el-option>
            </el-select>
          </div>
        </div>

        <div
          v-if="
            employeeDetails.paytype.pay_type == 'hourly' ||
            employeeDetails.paytype.pay_type == 'daily'
          "
          class="flex payType items-center my-4"
        >
          <p class="pb-1 w-1/4">Weekdays (Mon-Fri)</p>
          <div
            v-if="employeeDetails.paytype.pay_type == 'hourly'"
            class="w-1/4 relative"
          >
            <el-input
              v-model="employeeDetails.paytype.hourly_weekday_rate"
              class="baseInput"
              type="number"
              style="width: 100%"
              size="small"
            />
            <div
              v-if="employeeDetails.paytype.pay_type == 'hourly'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Hour
            </div>
            <div
              v-if="employeeDetails.paytype.pay_type == 'daily'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Day
            </div>
          </div>
          <div
            v-if="employeeDetails.paytype.pay_type == 'daily'"
            class="w-1/4 payType relative"
          >
            <el-input
              v-model="employeeDetails.paytype.daily_weekday_rate"
              class="baseInput"
              type="number"
              style="width: 100%"
              size="small"
            />
            <div
              v-if="employeeDetails.paytype.pay_type == 'hourly'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Hour
            </div>
            <div
              v-if="employeeDetails.paytype.pay_type == 'daily'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Day
            </div>
          </div>
        </div>

        <div
          v-if="
            employeeDetails.paytype.pay_type == 'hourly' ||
            employeeDetails.paytype.pay_type == 'daily'
          "
          class="flex items-center my-4"
        >
          <p class="pb-1 w-1/4">Weekends (Sat-Sun)</p>
          <div
            v-if="employeeDetails.paytype.pay_type == 'hourly'"
            class="w-1/4 payType relative"
          >
            <el-input
              v-model="employeeDetails.paytype.hourly_weekend_rate"
              class="baseInput"
              type="number"
              style="width: 100%"
              size="small"
            />
            <div
              v-if="employeeDetails.paytype.pay_type == 'hourly'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Hour
            </div>
            <div
              v-if="employeeDetails.paytype.pay_type == 'daily'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Day
            </div>
          </div>
          <div
            v-if="employeeDetails.paytype.pay_type == 'daily'"
            class="w-1/4 payType relative"
          >
            <el-input
              v-model="employeeDetails.paytype.daily_weekend_rate"
              class="baseInput"
              type="number"
              style="width: 100%"
              size="small"
            />
            <div
              v-if="employeeDetails.paytype.pay_type == 'hourly'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Hour
            </div>
            <div
              v-if="employeeDetails.paytype.pay_type == 'daily'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Day
            </div>
          </div>
        </div>

        <div
          v-if="employeeDetails.paytype.pay_type == 'weekly'"
          class="flex payType items-center my-4"
        >
          <p class="pb-1 w-1/4">Weekly Rate</p>
          <div class="w-1/4 relative">
            <el-input
              v-model="employeeDetails.paytype.weekly_rate"
              class="baseInput"
              type="number"
              style="width: 100%"
              size="small"
            />
            <div
              v-if="employeeDetails.paytype.pay_type == 'weekly'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Week
            </div>
          </div>
        </div>

        <div
          v-if="employeeDetails.paytype.pay_type == 'monthly'"
          class="flex payType items-center my-4"
        >
          <p class="pb-1 w-1/4">Monthly Rate</p>
          <div class="w-1/4 relative">
            <el-input
              v-model="employeeDetails.paytype.monthly_rate"
              class="baseInput"
              type="number"
              style="width: 100%"
              size="small"
            />
            <div
              v-if="employeeDetails.paytype.pay_type == 'monthly'"
              style="
                position: absolute;
                top: 10px;
                right: 25px;
                color: #ddd;
                font-size: 12px;
              "
            >
              INR Per Month
            </div>
          </div>
        </div>

        <!-- <div class="flex justify-between items-center my-4">
          <div class="flex w-full justify-between items-center">
            <p class="pb-1 pt-6">Shift Preference <br />(Start Time Range)</p>
            <div class="w-1/2">
              <div class="text-center my-4">24 Hrs Format</div>
              <div class="flex justify-between items-center">
                <div>
                  <el-time-select
                    v-model="employeeDetails.prefer_start_time"
                    style="max-width: 120px"
                    :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '23:59',
                    }"
                    placeholder="HH:mm"
                    :name="'prefer_start_time'"
                    size="small"
                    @change="$emit('staffOpenPopUp')"
                  ></el-time-select>
                  <p class="pt-2">Start Time</p>
                </div>
                <p class="w-4 text-center">&nbsp;</p>
                <div>
                  <el-time-select
                    v-model="employeeDetails.prefer_end_time"
                    style="max-width: 120px"
                    :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '23:59',
                    }"
                    placeholder="HH:mm"
                    :name="'prefer_end_time'"
                    size="small"
                    @change="$emit('staffOpenPopUp')"
                  >
                  </el-time-select>
                  <p class="pt-2">Max Start Time</p>
                </div>
              </div>
            </div>
          </div>

          <div class="flex w-full justify-around items-center">
            <p class="text-center pb-1 2/5"></p>
            <div class="w-3/5">
              <div class="flex justify-center items-center">
                <div>
                  <p class="pb-2">From</p>
                  <el-date-picker
                    v-model="employeeDetails.prefer_start_date"
                    type="date"
                    style="max-width: 140px"
                    placeholder="From Date"
                    size="small"
                    :picker-options="{
                      firstDayOfWeek: 1,
                    }"
                  >
                  </el-date-picker>
                </div>
                <p class="w-4 text-center">&nbsp;</p>
                <div>
                  <p class="pb-2">To</p>
                  <el-date-picker
                    v-model="employeeDetails.prefer_end_date"
                    type="date"
                    style="max-width: 140px"
                    placeholder="To Date"
                    size="small"
                    :picker-options="{
                      disabledDate: (date) => {
                        return date < employeeDetails.prefer_start_date;
                      },
                      firstDayOfWeek: 1,
                    }"
                  >
                  </el-date-picker>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="flex justify-between items-center my-4">
          <div class="flex w-full justify-between items-center">
            <p class="pb-1 pt-6">
              Weekly Off <br />
              Preference
            </p>
            <div class="w-1/2">
              <div>
                <p class="pb-2">&nbsp;</p>
                <el-select
                  v-model="employeeDetails.weekly_offs"
                  style="width: 200px"
                  placeholder="Select Off Days"
                  multiple
                  collapse-tags
                  size="small"
                  @change="$emit('staffOpenPopUp')"
                  :disabled="!employeeDetails.employee_type"
                >
                  <el-option
                    v-for="(days, daysIndex) in planningShiftDayList"
                    :key="daysIndex"
                    :value="days.id"
                    :label="days.day"
                    :disabled="
                      disableWeeklyOffPreference(
                        employeeDetails.weekly_offs,
                        days.id
                      )
                    "
                  >
                    {{ days.day }}
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="flex w-full justify-around items-center">
            <p class="text-center pb-1 2/5"></p>
            <div class="w-3/5">
              <div class="flex justify-center items-center">
                <div>
                  <p class="pb-2">From</p>
                  <el-date-picker
                    v-model="employeeDetails.weekly_off_start_date"
                    type="date"
                    style="max-width: 140px"
                    placeholder="From Date"
                    size="small"
                    :picker-options="{
                      firstDayOfWeek: 1,
                    }"
                  >
                  </el-date-picker>
                </div>
                <p class="w-4 text-center">&nbsp;</p>
                <div>
                  <p class="pb-2">To</p>
                  <el-date-picker
                    v-model="employeeDetails.weekly_off_end_date"
                    type="date"
                    style="max-width: 140px"
                    placeholder="To Date"
                    size="small"
                    :picker-options="{
                      disabledDate: (date) => {
                        return date < employeeDetails.weekly_off_start_date;
                      },
                      firstDayOfWeek: 1,
                    }"
                  >
                  </el-date-picker>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div v-if="storeDetails.shift_type == 'fixed'" class="flex items-center my-4">
          <p class="pb-1 w-1/4">Shift Preference</p>
          <div class="w-1/4">
            <el-select
              v-model="employeeDetails.fixed_shift_preferances"
              style="width: 100%"
              placeholder="Shift Name"
              size="small"
              multiple
              @change="$emit('staffOpenPopUp')"
              collapse-tags
            >
              <el-option
                v-for="(shift, shiftIndex) in shifts"
                :key="shiftIndex"
                :value="shift.id"
                :label="shift.shift_name"
              >
                {{ shift.shift_name }}
              </el-option>
            </el-select>
          </div>
        </div> -->
      </div>
        <div class="flex justify-end">
          <div class="buttons-parrent2" style="display: flex; justify-content: flex-end">
            <div class="mx-4 mt-8">
              <BaseButton
                type="submit"
                style="width: 100px"
                buttonclass="btn p-2 text-xs cancel-btn"
                @click="$emit('closeEditEmployeePopup')"
              >
                Cancel
              </BaseButton>
            </div>
          </div>

          <div class="buttons-parrent2 flex items-end">
            <div v-if="employeeData === undefined" class="mx-2 mt-8">
              <BaseButton
                type="submit"
                style="width: 100px"
                buttonclass="btn p-2 text-xs submit-btn"
                :disabled="!responseData.response_code"
                @click="addEmployeeData"
              >
                Save
              </BaseButton>
            </div>
            <div v-else class="mx-2 mt-8">
              <BaseButton
                type="submit"
                style="width: 100px"
                buttonclass="btn p-2 text-xs submit-btn"
                :disabled="Object.keys(responseData).length ? !responseData.response_code : false"
                @click="updateEmployeeData"
              >
                Update
              </BaseButton>
            </div>
          </div>
        </div>
      </div>

      <!-- skills section -->
      <div v-if="!toggle_emp_form" v-loading="is_skill_list_loading">
        <table class="added-skills-table">
          <thead>
            <tr>
              <th style="width: 40%;">STATION</th>
              <th style="width: 25%;">DATE TRAINED</th>
              <th style="width: 25%;">RATING</th>
              <th style="width: 10%;">&nbsp;</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(skill, skill_index) in added_skill_list" :key="skill_index" style="border-bottom: 1px solid #eee;">
              <td style="width: 40%; text-align: center;">
                {{ skill.function ? getFunctionName(skill.function) : 'NA' }}
              </td>

              <td style="width: 25%; text-align: center;">
                {{ skill.trained_date ? moment(skill.trained_date).format('DD MMM YYYY') : 'NA' }}
              </td>

              <td style="width: 25%; text-align: center; text-transform: capitalize;">
                {{ skill.skill_level ? getSkillLevel(skill.skill_level) : 'NA' }}
              </td>

              <td style="width: 10%; text-align: center;">
                <img
                  class="cursor-pointer"
                  width="20px"
                  src="../../../../../../assets/images/edit.png"
                  alt="Edit"
                  @click="skill.is_editable = true"
                />

                <img
                  class="cursor-pointer ml-2"
                  width="20px"
                  src="../../../../../../assets/images/delete-icon.png"
                  alt="Delete"
                  @click="deleteSkill(skill_index)"
                />
              </td>
              
              <table v-if="skill.is_editable" style="width: 100%;">
                <tr>
                  <td style="width: 33.33%;">
                    <el-select v-model="skill.edit_function" size="mini" placeholder="Select function" style="width: 100%;">
                      <el-option
                        v-for="item in functions"
                        :key="item.id"
                        :label="item.function"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </td>

                  <td style="width: 33.33%; text-align: center;">
                    <el-date-picker v-model="skill.edit_trained_date" type="date" size="mini" placeholder="Select date" style="width: 100%;"></el-date-picker>
                  </td>

                  <td style="width: 33.33%; text-align: center;">
                    <el-select v-model="skill.edit_skill_level" size="mini" placeholder="Select rating" style="width: 100%;">
                      <el-option
                        v-for="item in rating_type_list"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </td>
                </tr>
                
                <tr>
                  <td style="width: 100%; height: 70px;">
                    <div class="flex">
                      <el-button size="mini" class="action-btn" @click="skill.is_editable = false">Cancel</el-button>
                      <el-button size="mini" class="action-btn" @click="saveEditedSkill(skill_index)">Save</el-button>
                    </div>
                  </td>
                </tr>
              </table>
            </tr>
          </tbody>
        </table>

        <div v-if="!added_skill_list.length && !create_skill_list.length" style="text-align: center; font-size: 14px; font-weight: 600; color: #e29d5a; padding: 15px;">
          No data available
        </div>

        <!-- add skill details -->
        <table class="create-skill-set-table mt-6">
          <tbody>
            <tr v-for="(skill, skill_index1) in create_skill_list" :key="skill_index1">
              <td style="width: 40%;">
                <el-select v-model="skill.function" size="mini" placeholder="Select function" style="width: 100%;">
                  <el-option
                    v-for="item in functions"
                    :key="item.id"
                    :label="item.function"
                    :value="item.id">
                  </el-option>
                </el-select>
              </td>

              <td style="width: 25%; text-align: center;">
                <el-date-picker v-model="skill.trained_date" type="date" size="mini" placeholder="Select date"></el-date-picker>
              </td>

              <td style="width: 25%; text-align: center;">
                <el-select v-model="skill.skill_level" size="mini" placeholder="Select rating">
                  <el-option
                    v-for="item in rating_type_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </td>

              <td style="width: 10%; text-align: center;">
                <img
                  class="cursor-pointer ml-2"
                  width="20px"
                  src="../../../../../../assets/images/delete-icon.png"
                  alt="Delete"
                  @click="removeItemFromCreateSkillList(skill_index1)"
                />
              </td>
            </tr>

            <tr>
              <td colspan="3">
                <BaseButton
                  type="submit"
                  style="width: 100px"
                  buttonclass="btn p-2 text-xs submit-btn"
                  @click="addItemToCreateSkillList()"
                >
                  Add More
                </BaseButton>
              </td>
            </tr>
          </tbody>
        </table>

        <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
          <!-- <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs"
          >
            Cancel
          </BaseButton> -->

          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs ml-2 submit-btn"
            @click="saveSkillsList()"
          >
            Save
          </BaseButton>
        </div>
      </div>

      <!-- <div v-if="storeDetails.shift_type == 'flexible'" class="flex justify-between items-center mt-12 mb-4">
        <div class="flex justify-between items-center">
          <div class=" w-1/2">
            <p class=" pb-1">&nbsp;</p>
            <p class=" pb-1 pt-6 ">Shift Preference <br>(Start Time Range)</p>
            </div>
            <div class="w-1/2">
            <div class="text-center my-4">24 Hrs Fromat</div>
            <div class="flex justify-between items-center">
            <div>
            <el-time-select
            v-model="employeeDetails.prefer_start_time"
            style="max-width: 120px"
            :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '23:59'
            }"
            placeholder="HH:mm"
            :name="'prefer_start_time'"
            size="small"
            @change="$emit('staffOpenPopUp')"
            ></el-time-select>
            <p class="pt-2">Start Time</p>
            </div>
            <p class="w-4 text-center ">&nbsp;</p>
            <div>
            <el-time-select
            v-model="employeeDetails.prefer_end_time"
            style="max-width: 120px"
            :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '23:59'
            }"
            placeholder="HH:mm"
            :name="'prefer_end_time'"
            size="small"
            @change="$emit('staffOpenPopUp')"
            >
            </el-time-select>
            <p class="pt-2">Max Start Time</p>
            </div>
            </div>
            </div>
            </div>
            <div class="flex items-center">
            <div>
            <div class="flex justify-center items-center">
            <div>
            <p class="pb-2">From</p>
            <el-date-picker
            v-model="employeeDetails.prefer_start_date"
            type="date"
            style="max-width: 140px"
            placeholder="From Date"
            size="small"
            :picker-options="{
            firstDayOfWeek: 1
            }"
            >
            </el-date-picker>
        </div>
        <p class="w-4 text-center">&nbsp;</p>
        <div>
        <p class="pb-2">To</p>
        <el-date-picker
        v-model="employeeDetails.prefer_end_date"
        type="date"
        style="max-width: 140px"
        placeholder="To Date"
        size="small"
        :picker-options="{
        disabledDate: date => {
        return date < employeeDetails.prefer_start_date;
        },
        firstDayOfWeek: 1
        }"
        >
        </el-date-picker>
        </div>
        </div>
        </div>
        </div>
        </div> -->

        <!-- <div class="flex justify-between items-center mt-2 mb-4">
        <div class="flex justify-between items-center">
        <div class=" w-1/3">
        <p class=" pb-1 pt-6" style="width: 240px;">Weekly Off <br> Preference</p>
        </div>
        <div class="w-2/3">
        <div class="flex justify-between items-center">
        <div>
        <p class=" pb-2">&nbsp;</p>
        <el-select
        v-model="employeeDetails.weekly_offs"
        style="width: 200px"
        placeholder="Select Off Days"
        multiple
        collapse-tags
        size="small"
        @change="$emit('staffOpenPopUp')"
        :disabled="!employeeDetails.employee_type"
        >
        <el-option
        v-for="(days, daysIndex) in planningShiftDayList"
        :key="daysIndex"
        :value="days.id"
        :label="days.day"
        :disabled="disableWeeklyOffPreference(employeeDetails.weekly_offs, days.id)"
        >
        {{ days.day }}
        </el-option>
        </el-select>
        </div>
        </div>
        </div>
        </div>
        <div class="flex items-center">
        <div>
        <div class="flex justify-center items-center">
        <div>
        <p class="pb-2">From</p>
        <el-date-picker
        v-model="employeeDetails.weekly_off_start_date"
        type="date"
        style="max-width: 140px"
        placeholder="From Date"
        size="small"
        :picker-options="{
        firstDayOfWeek: 1
        }"
        >
        </el-date-picker>
        </div>
        <p class="w-4 text-center">&nbsp;</p>
        <div>
        <p class="pb-2">To</p>
        <el-date-picker
        v-model="employeeDetails.weekly_off_end_date"
        type="date"
        style="max-width: 140px"
        placeholder="To Date"
        size="small"
        :picker-options="{
        disabledDate: date => {
        return date < employeeDetails.weekly_off_start_date;
        },
        firstDayOfWeek: 1
        }"
        >
        </el-date-picker>
        </div>
        </div>
        </div>
        </div>
        </div> -->

              <!-- <div class="flex justify-between items-center my-4">
        <div class="flex w-full justify-between items-center">
        <div class="w-1/3">
        <p class=" pb-1">&nbsp;</p>
        <p class=" pb-1 pt-8 ">Weekly Off Preference</p>
        </div>
        <div class="w-2/3">
        <div class="text-center my-4">&nbsp;</div>
        <div class="flex justify-between items-center">
        <el-select
        v-model="employeeDetails.weekly_offs"
        style="width: 100%"
        placeholder="Select Off Days"
        multiple
        collapse-tags
        size="small"
        @change="$emit('staffOpenPopUp')"
        >
        <el-option
        v-for="(days, daysIndex) in planningShiftDayList"
        :key="daysIndex"
        :value="days.id"
        :label="days.day"
        >
        {{ days.day }}
        </el-option>
        </el-select>
        </div>
        </div>
        </div>
        <div class="flex w-full justify-around items-center">
        <div class="w-5/6">
        <div class="flex justify-center items-center">
        <div>
        <p class="pb-2">From</p>
        <el-date-picker
        v-model="employeeDetails.weekly_off_start_date"
        type="date"
        style="max-width: 160px"
        placeholder="From Date"
        size="small"
        :picker-options="{
        firstDayOfWeek: 1
        }"
        >
        </el-date-picker>
        </div>
        <p class="w-16 text-center">&nbsp;</p>
        <div>
        <p class="pb-2">To</p>
        <el-date-picker
        v-model="employeeDetails.weekly_off_end_date"
        type="date"
        style="max-width: 160px"
        placeholder="To Date"
        size="small"
        :picker-options="{
        disabledDate: date => {
        return date < employeeDetails.weekly_off_start_date;
        },
        firstDayOfWeek: 1
        }"
        >
        </el-date-picker>
        </div>
        </div>
        </div>
        </div>
        </div> -->
    </div>

    <!-- add new function dialog -->
    <el-dialog
      title="Add Desgination"
      :visible.sync="add_new_designation_dialog"
      width="50%"
    >
      <div v-loading="is_designation_list_loading">
        <div
          id="add-designation-wrapper"
          style="height: 200px; overflow-y: auto"
        >
          <div
            v-for="(designation, designation_index) in add_designation_list"
            :key="designation_index"
            class="py-2 flex items-center"
          >
            <el-input
              v-model="designation.name"
              :placeholder="'Designation ' + (designation_index + 1)"
              size="medium"
              style="width: 50%"
              type="text"
              @input="designation.isChange = true"
            />

            <div class="ml-5">
              <img
                class="cursor-pointer"
                src="../../../../../../assets/images/delete-icon.png"
                alt="Delete"
                width="22px"
                @click="deleteDesignation(designation_index)"
              />
            </div>
          </div>
        </div>

        <div class="flex items-center mt-5">
          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs"
            @click="addMoreDesignations()"
          >
            Add More
          </BaseButton>
        </div>
      </div>

      <span
        slot="footer"
        class="dialog-footer flex"
        style="justify-content: flex-end"
      >
        <BaseButton
          type="submit"
          style="width: 100px"
          buttonclass="btn p-2 text-xs"
          @click="add_new_designation_dialog = false"
        >
          Cancel
        </BaseButton>

        <BaseButton
          type="submit"
          style="width: 100px"
          buttonclass="btn p-2 text-xs ml-2"
          @click="addUpdateDesignation()"
        >
          Update
        </BaseButton>
      </span>
    </el-dialog>

     <el-dialog title="Warning" :visible.sync="warningDialogVisibility" width="470px">
      <div style="text-align: left">
        <h4>Please Note -</h4>
        <br />
        <p>Employee and all related information will be moved to archive</p>
        <br />
        <p>Do you wish to continue?</p>
      </div>

      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-around;">
        <BaseButton
          type="submit"
          style="width: 100px"
          buttonclass="btn p-2 text-xs"
          @click="closeWarningDialog()"
        >
          Cancel
        </BaseButton>

        <BaseButton
          type="submit"
          style="width: 100px"
          buttonclass="btn p-2 text-xs"
          @click="warningDialogVisibility = false"
        >
          Confirm
        </BaseButton>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from "../../../../../../eventBus";
import { serverAddr } from "../../../../../../networkConfig";
import LabourPalnningService from "../../../../../../services/labourPalnningService";
import moment from 'moment';
import { mapState } from "vuex";

export default {
  name: "StaffEmployeePopup",
  mixins: [],
  props: {
    employeeData: {
      type: Object,
      default: () => {},
    },
    newEmployeeData: {
      type: Object,
      default: () => {},
    },
    showAddEmployeePopup: {
      type: Boolean,
      default: () => 0,
    },
    employeeIndex: {
      type: Number,
      default: () => 0,
    },
    planningShiftDayList: {
      type: Array,
      default: () => [],
    },
    functions: {
      type: Array,
      default: () => [],
    },
    employeeList: {
      type: Array,
      default: () => [],
    },
    shifts: {
      type: Array,
      default: () => [],
    },
    departmentList: {
      type: Array,
      default: () => [],
    },
    storeId: {
      type: String,
      default: () => '',
    },
    // designationList: {
    //   type: Array,
    //   default: () => [],
    // },
    storeList: {
      type: Array,
      default: () => [],
    },
    storeName: {
      type: String,
      default: () => "",
    },
    fullTimeMin: {
      type: String,
      default: () => "",
    },
    partTimeMin: {
      type: String,
      default: () => "",
    },
    fullTimeHours: {
      type: String,
      default: () => "",
    },
    partTimeHours: {
      type: String,
      default: () => "",
    },
    storeDetails: {
      type: Object,
      default: () => {},
    },
    fullTimeWeeklyOff: {
      type: Number,
      default: () => "",
    },
    partTimeWeeklyOff: {
      type: Number,
      default: () => "",
    },
    storeDesignationList: {
      type: Array,
      default: () => []
    },
    secondaryStores: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      gender_list: ["Male", "Female", "Others"],
      select_shift_list: ["Full Time", "Part Time"],
      selectedPrimaryRole: "",
      selectedRole: "",
      color: [
        "#51d88a",
        "#64d5ca",
        "#6cd2eb",
        "#7886d7",
        "#a779e9",
        "#fa7ea8",
        "#e28c57",
        "#ffbbca",
      ],
      uniqId: "",
      uniqEmail: true,
      employeeDetails:
        this.employeeData === undefined
          ? this.newEmployeeData
          : this.employeeData,
      filtered_functions: [],
      add_designation_list: [],
      add_new_designation_dialog: false,
      is_designation_list_loading: false,
      selectedEmpId: '',
      toggle_emp_form: true,
      rating_type_list: [
        {
          label: 'Learning',
          value: 1,
        },
        {
          label: 'Owning',
          value: 2,
        }
      ],

      added_skill_list: [],
      create_skill_list: [
        {
          id: null,
          function: '',
          trained_date: '',
          skill_level: ''
        }
      ],

      is_skill_list_loading: false,
      moment: moment,
      previous_desig: '',
      warningDialogVisibility: false,
      responseData: {}
    };
  },

  computed: {
    ...mapState("CommonStore", ["companyData"]),
    designations() {
      return this.$store.state.designations;
    },
    isMySB() {
      let data = JSON.parse(localStorage.getItem('check_company'));
      return data.is_sb_malaysia;
    },
    designationList() {
      let data = [...this.storeDesignationList];
      data = data.sort((a,b) => a.name.localeCompare(b.name))
      return data;
    }
  },

  mounted() {
    // this.getDesignationList();
    this.filtered_functions = this.functions.slice(0);

    // to display filtered functions by department while editing team/staff details
    if (this.employeeDetails.store_department) {
      let function_list = this.functions.slice(0);

      this.filtered_functions = function_list;
    }

    if (
      this.employeeDetails.secondary_functions &&
      this.employeeDetails.secondary_functions.length
    ) {
      this.displayedRole(this.employeeDetails.secondary_functions);
    }

    if (this.employeeDetails.function) {
      this.selectPrimary(this.employeeDetails.function);
    }
    this.employeeDetails.active = true;
  },

  methods: {
    closeWarningDialog(){
      this.employeeDetails.active = true;
      this.warningDialogVisibility = false;
    },

    openWarningDialog(){
      this.$emit('staffOpenPopUp');

      if(!this.employeeDetails.active){
        this.warningDialogVisibility = true;
      }
    },

    toggleEmpSection(toggle){
      if(toggle){
        this.toggle_emp_form = true;
      }else{
        this.toggle_emp_form = false;

        this.getSkillsList();
      }
    },

    addItemToCreateSkillList(){
      this.create_skill_list.push(
        {
          id: null,
          function: '',
          trained_date: '',
          skill_level: ''
        }
      )
    },

    deleteSkill(index){
      if(this.added_skill_list[index].id){
        this.is_skill_list_loading = true;  //enabled loader

        serverAddr
        .post(`/delete/employee_skill_mapping/`, {
          id: this.added_skill_list[index].id
        })
        .then((res) => {
          if(res.status == 200){

            this.$notify.success({
              title: "Success",
              message: 'Skill removed'
            });

            this.added_skill_list.splice(index, 1);

          }
          this.is_skill_list_loading = false;  //disabled loader
        })
        .catch((err) => {
          console.log(err);
          this.is_skill_list_loading = false;  //disabled loader
        });

      }else{
        this.$notify.error({
          title: "Error",
          message: 'Failed to remove skill'
        });
      }
    },

    removeItemFromCreateSkillList(index){
      this.create_skill_list.splice(index, 1);
    },

    addItemsToSkillList(){
      for(let i=0; i<this.create_skill_list.length; i++){
        if(this.create_skill_list[i].function && this.create_skill_list[i].trained_date && this.create_skill_list[i].skill_level){
          this.added_skill_list.push(this.create_skill_list[i]);
        }
      }

      this.create_skill_list = [
        {
          id: null,
          function: '',
          trained_date: '',
          skill_level: ''
        }
      ]
    },

    getSkillsList() {
      this.is_skill_list_loading = true;  //enabled loader

      serverAddr
        .post(`/read/employee_skill_mapping/`, {
          id: this.employeeData.id
          // id: 2511
        })
        .then((res) => {
          let response = JSON.parse(res.data);

          for(let i=0; i<response.length; i++){
            response[i].is_editable = false;      //created editable field to edit skill
            response[i].edit_function = response[i].function;
            response[i].edit_trained_date = response[i].trained_date;
            response[i].edit_skill_level = response[i].skill_level;
          }

          this.added_skill_list = response;
          
          this.is_skill_list_loading = false;  //disabled loader
        })
        .catch((err) => {
          console.log(err);
          this.is_skill_list_loading = false;  //disabled loader
        });
    },

    saveSkillsList() {
      this.is_skill_list_loading = true;  //enabled loader

      let skill_set_list = [];

      for(let i=0; i<this.create_skill_list.length; i++){
         if(this.create_skill_list[i].function && this.create_skill_list[i].trained_date && this.create_skill_list[i].skill_level){

            let obj = {
              employee: this.employeeData.id,
              function: this.create_skill_list[i].function,
              skill_level: this.create_skill_list[i].skill_level,
              trained_date: moment(this.create_skill_list[i].trained_date).format('YYYY-MM-DD')
            }

            if(this.create_skill_list[i].id){
              obj.id =  this.create_skill_list[i].id;
            }

            skill_set_list.push(obj);
         }

      }

      if(skill_set_list.length){
        serverAddr
        .post(`/save/employee_skill_mapping/`, skill_set_list)
        .then((res) => {
          if(res.status == 200){
            this.$notify.success({
              title: "Success",
              message: 'Skill updated'
            });

            this.create_skill_list = [
              {
                id: null,
                function: '',
                trained_date: '',
                skill_level: ''
              }
            ]

            this.getSkillsList();
          }
          this.is_skill_list_loading = false;  //disabled loader
        })
        .catch((err) => {
          console.log(err);
          this.is_skill_list_loading = false;  //disabled loader
        });
      }else{
        this.is_skill_list_loading = false;  //disabled loader

        this.$notify.error({
          title: "Error",
          message: 'Add skills first'
        });
      }

		},

    saveEditedSkill(index){
      this.is_skill_list_loading = true;  //enabled loader

      this.added_skill_list[index].function = this.added_skill_list[index].edit_function;
      this.added_skill_list[index].trained_date = this.added_skill_list[index].edit_trained_date;
      this.added_skill_list[index].skill_level = this.added_skill_list[index].edit_skill_level;


      let skill_set_list = [];

      if(this.added_skill_list[index].function && this.added_skill_list[index].skill_level && this.added_skill_list[index].trained_date){
        let obj = {
          employee: this.employeeData.id,
          function: this.added_skill_list[index].function,
          skill_level: this.added_skill_list[index].skill_level,
          trained_date: moment(this.added_skill_list[index].trained_date).format('YYYY-MM-DD'),
          id: this.added_skill_list[index].id
        }
        
        skill_set_list.push(obj);

        serverAddr
        .post(`/save/employee_skill_mapping/`, skill_set_list)
        .then((res) => {
          if(res.status == 200){

            this.$notify.success({
              title: "Success",
              message: 'Skill updated'
            });

            this.getSkillsList();
          }

          this.is_skill_list_loading = false;  //disabled loader
        })
        .catch((err) => {
          console.log(err);
          this.is_skill_list_loading = false;  //disabled loader
        });

      }else{
        this.is_skill_list_loading = false;  //disabled loader

        this.$notify.error({
          title: "Error",
          message: 'Enter all fields'
        });
      }
    },

    getSkillLevel(skill){
      let item = '';

      this.rating_type_list.forEach(e => {
        if(skill == e.value){
          item = e.label;
        }
      });

      return item;
    },

    getFunctionName(function_id){
      let item = '';

      this.functions.forEach(e => {
        if(function_id == e.id){
          item = e.function;
        }
      });

      return item;
    },

    getDesignationList() {
      serverAddr
        .post(`/users/designations/list/`)
        .then((res) => {
          let response = JSON.parse(res.data);
          // this.designationList = response;

          // this.accountUserDetails.designation = this.designationList[0].id
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectDesignInfo(desig) {
      this.designationList.forEach((element) => {
        if (element.id == desig) {
          this.employeeDetails.designation_info.id = element.id;
        }
      });
    },
    addDesignation(event) {
      if (event == "add new") {
        this.employeeDetails.designation = "";
        this.add_designation_list = this.designationList.slice(0); //get shadow copy of array
        this.add_designation_list.forEach((element) => {
          if (element.id) {
            element.isChange = false;
          }
        });
        this.add_new_designation_dialog = true;
      }
    },

    addMoreDesignations() {
      let designation = {
        name: "",
      };

      this.add_designation_list.unshift(designation);

      // to scroll to top of div after adding one more item to list
      this.scrollToTop("add-designation-wrapper");
    },

    addUpdateDesignation() {
      this.is_designation_list_loading = true; //displyed loader
      this.add_designation_list.forEach((element) => {
        if (element.name.length) {
          if (!element.id) {
            serverAddr
              .post(`/users/designations/save/`, {
                name: element.name,
              })
              .then((response) => {
                if (response.status == 200) {
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else if (element.id && element.isChange) {
            serverAddr
              .patch(`/users/designations/${element.id}/`, {
                name: element.name,
              })
              .then((response) => {
                if (response.status == 200) {
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }
      });

      setTimeout(() => {
        this.$notify.success({
          title: "Success",
          message: "Designation updated..!",
        });
        // this.getDesignationList();
        this.is_designation_list_loading = false;
        this.add_new_designation_dialog = false;
      }, 2000);
    },

    scrollToTop(div) {
      var objDiv = document.getElementById(div);
      objDiv.scrollTo(0, 0);
      // objDiv.scrollTop = objDiv.scrollHeight + '20px';
    },

    deleteDesignation(index) {
      this.is_designation_list_loading = true; //displyed loader
      let designation_id = this.add_designation_list[index].id;
      if (designation_id != undefined) {
        serverAddr
          .delete(`/users/designations/${designation_id}`)
          .then((response) => {
            this.add_designation_list.splice(index, 1);

            setTimeout(() => {
              // this.getDesignationList();
              this.is_designation_list_loading = false; //disabld loader
              this.$notify.success({
                title: "Success",
                message: "Designation removed..!",
              });
            }, 2000);
          })
          .catch((e) => {
            console.log("error", e);
            this.is_designation_list_loading = false; //disabld loader
          });
      } else {
        this.add_designation_list.splice(index, 1);
      }
    },

    checkValidation(id) {
      // remove space and convert into lowervase
      id = id.replace(/\s/g, "").toLowerCase();
      if (id) {
        serverAddr
          .post(`/read/check-emp-id/`, {
            emp_id: id,
            store: this.storeDetails.length ? this.storeDetails.store : this.storeName,
          })
          .then((res) => {
            if (res.data) {
              let response = JSON.parse(res.data);
              this.responseData = response;
              this.uniqId = response;
              this.employeeDetails.employee_id = id;
            } else {
              this.uniqId = "";
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    checkValidationByAPIEmail(email) {
      if (email) {
        serverAddr
          .post(`/users/status/`, {
            email: email,
          })
          .then((res) => {
            // console.log(res.data);
            let response = JSON.parse(res.data);
            console.log("response");
            if (response.message == "This user is not registered") {
              this.uniqEmail = true;
              // this.$notify.warning({
              // title: "Warning",
              // message: response.message,
              // });
            } else {
              this.uniqEmail = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

   changedPayType(type) {
      if (type == "hourly") {
        this.employeeDetails.weekly_rate = null;
        this.employeeDetails.monthly_rate = null;
      } else if (type == "daily") {
        this.employeeDetails.daily_weekday_rate = null;
        this.employeeDetails.daily_weekend_rate = null;
        this.employeeDetails.monthly_rate = null;
        this.employeeDetails.weekly_rate = null;
      } else if (type == "weekly") {
        this.employeeDetails.daily_weekday_rate = null;
        this.employeeDetails.daily_weekend_rate = null;
        this.employeeDetails.hourly_weekday_rate = null;
        this.employeeDetails.hourly_weekend_rate = null;
        this.employeeDetails.monthly_rate = null;
      } else if (type == "monthly") {
        this.employeeDetails.daily_weekday_rate = null;
        this.employeeDetails.daily_weekend_rate = null;
        this.employeeDetails.hourly_weekday_rate = null;
        this.employeeDetails.hourly_weekend_rate = null;
        this.employeeDetails.weekly_rate = null;
      }
    },
    selectFunction() {
      for (let i in this.employeeDetails.function) {
        if (this.employeeDetails.function[i] == "selectAll") {
          this.employeeDetails.function = this.filtered_functions.map(
            (e) => e.id
          );
          break;
        } else if (this.employeeDetails.function[i] == "clearAll") {
          this.employeeDetails.function = [];
        }
      }
      // console.log(this.employeeDetails.function);
    },
    // function to filter function list by department
    filterFunctionsByDepartment(department) {
      let function_list = this.functions.slice(0);
      return function_list;
    },

    updateEmployeeData() {
      this.$validator.validateAll()
      .then(async (result) => {
        if (result) {
          this.employeeDetails.skill_list = JSON.parse(JSON.stringify(this.added_skill_list))
          EventBus.$emit("updatedEmployeeData", this.employeeDetails, this.employeeIndex);
          // this.$emit("closedPopup");
          this.$emit("staffOpenPopUp");
          this.$emit("callSaveAPI");
        } else {
          this.$message.error("Required fields are missing");
        }
      });
    },

    addEmployeeData() {
      this.$validator.validateAll().then((result) => {
        if (result && !this.uniqId.length && this.uniqEmail) {
          EventBus.$emit("saveNewEmployeeData", this.employeeDetails, this.employeeIndex);
          this.$emit("staffOpenPopUp");
          // this.$emit("closedPopup");
          this.$emit("callSaveAPI");
        } else {
          if (this.uniqId.length) {
            this.$message.error("Please provide a unique Employee id");
          } else if (!this.uniqEmail) {
            this.$message.error("Please provide a unique email id");
          } else {
            this.$message.error("Required fields are missing");
          }
        }
      });
    },

    setTotalHrs(index, type) {
      if (type === "Full Time") {
        this.employeeDetails.duration =
          this.fullTimeHours + ":" + this.fullTimeMin;
      } else {
        // console.log(type, this.partTimeHours);
        this.employeeDetails.duration =
          this.partTimeHours + ":" + this.partTimeMin;
      }
    },

    displayedRole(list) {
      this.selectedRole = [];
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < this.functions.length; j++) {
          if (this.functions[j].id == list[i]) {
            let obj = {
              color: this.color[i],
              id: this.functions[j].id,
              function: this.functions[j].function,
            };
            this.selectedRole.push(obj);
          }
        }
      }
      // console.log(this.selectedRole);
    },

    selectPrimary(role) {
      for (let j = 0; j < this.functions.length; j++) {
        if (this.functions[j].id == role) {
          this.selectedPrimaryRole = this.functions[j].function;
        }
      }
    },

    disableWeeklyOffPreference(preference, days) {
      if (this.employeeDetails.employee_type == "Full Time") {
        if (
          preference.length == Number(this.fullTimeWeeklyOff) &&
          !preference.includes(days)
        ) {
          return true;
        }
      } else if (
        this.employeeDetails.employee_type == "Part Time" &&
        !preference.includes(days)
      ) {
        if (preference.length == Number(this.partTimeWeeklyOff)) {
          return true;
        }
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../staffEmployeePopup/staffEmployeePopup.scss";
</style>
<style>
.staffEmployeePopup .el-input__inner {
  font-size: 12px;
}
.payType .el-input__inner {
  padding: 0 0 0 15px;
}
.email .el-input__inner {
  text-transform: unset !important;
}
</style>

<style>
.btn.submit-btn {
  background: #D26300;
  border-color: #D26300;
  color: #FFFFFF;
}
.btn.submit-btn:focus, .btn.submit-btn:active, .btn.submit-btn:hover {
  background: #D26300;
  border-color: #D26300;
  color: #FFFFFF;
  outline: none;
}
.btn.cancel-btn {
  background: #FFFFFF;
  border-color: #D26300;
  color: #D26300;
}
.btn.cancel-btn:focus, .btn.cancel-btn:active, .btn.cancel-btn:hover {
  background: #FFFFFF;
  border-color: #D26300;
  color: #D26300;
  outline: none;
}
.flex.w-full.justify-between.items-center {
  margin-bottom: 20px;
}
</style>